import RoutesCreerTitreDetention from './creer/routes';
import RoutesVisualiserTitreDetention from './visualiser/routes';
import { initSubRoutes } from '../../../../utils/router';

const RoutesTitreDetention = initSubRoutes({
    route: '/titre-detention',
    subroutes: {
        creer: RoutesCreerTitreDetention,
        visualiser: RoutesVisualiserTitreDetention,
    },
    nom: 'Titre de détention',
});

export default RoutesTitreDetention;
